import React, { useEffect, useState, createContext } from 'react';

const WidthContext = createContext({
  width: window.innerWidth,
  viewSize: null,
  touch: false
});

function WidthContextProvider({ children }) {
  const [width, setWidth] = useState(window.innerWidth);
  const [touch, setTouch] = useState(false);
  const [viewSize, setViewSize] = useState();

  useEffect(() => {
    const handleResize = () => {
      const current = window.innerWidth;
      setWidth(current);
      if (current > 768) {
        setViewSize('large');
      } else {
        setViewSize('small');
      }
    };
    const handleTouch = () => {
      setTouch(true);
      return () => window.removeEventListener('touchstart', handleTouch);
    };
    window.addEventListener('touchstart', handleTouch, { passive: true });

    window.addEventListener('resize', handleResize, { passive: true });
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('touchstart', handleTouch);
    };
  }, []);
  return (
    <WidthContext.Provider value={{ width, viewSize, touch }}>{children}</WidthContext.Provider>
  );
}

export { WidthContext, WidthContextProvider };
